module.exports = __webpack_public_path__ + "static/media/accessories2.711d2578.jpg";